import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Data,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { AuthenticationService } from '../authentication/authentication.service';
import { Observable } from 'rxjs';
import { NavbarService } from '../components/navbar/navbar.service';
import { PermissionService } from '../services/permission.service';

import { Store } from '@ngxs/store';
import { featureFlag } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class EContractGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    if (!featureFlag.econtract_enable) {
      this.router.navigate(['/page-not-found'], {
        queryParams: { permission: true },
      });
    }

    return featureFlag.econtract_enable;
  }

  // tslint:disable-next-line:max-line-length
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!featureFlag.econtract_enable) {
      this.router.navigate(['/page-not-found'], {
        queryParams: { permission: true },
      });
    }

    return featureFlag.econtract_enable;
  }
}
